<style lang="scss" scoped>
.v-icon {
  display: block;
}
</style>

<template>
  <transition name="fade" mode="out-in">
    <dr-vector
      class="v-icon"
      :key="fill"
      :fill.sync="fill"
      :color="color"
      :src.sync="svg"
    />
  </transition>
</template>
<script>
import icons from './icons.js'

export default {
  props: [
    'height',
    'fill',
    'name',
    'color'
  ],

  computed: {
    svg () {
      return icons[this.name]
    }
  }
}
</script>
